<div class="tab-wrapper d-flex">
  <ng-content></ng-content>
</div>
